import { DocumentIcon } from "../fancyIcons";
import { getUrl } from "aws-amplify/storage";
import useOptimizedImageKey from "../hooks/useOptimizedImageKey";
import { MessageAttachment } from "./Conversation";
import { ImageThumbnailsWithModal } from "../ImageThumbnailsWithModal";
const IMAGE_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "webp",
  "svg",
  "ico",
];

const ConversationMessageAttachments = ({
  attachments,
}: {
  attachments: MessageAttachment[];
}) => {
  const getDownloadUrlAndOpen = async (key: string) => {
    const url = await getUrl({ path: key });
    window.open(url.url, "_blank");
  };

  const imageAttachments = (attachments ?? []).filter((attachment) => {
    const extension = attachment.fileName.split(".").pop()?.toLowerCase();
    return extension && IMAGE_EXTENSIONS.includes(extension);
  });

  const nonImageAttachments = (attachments ?? []).filter((attachment) => {
    const extension = attachment.fileName.split(".").pop()?.toLowerCase();
    return extension && !IMAGE_EXTENSIONS.includes(extension);
  });

  return (
    <>
      {imageAttachments.length > 0 && (
        <div className="f-hidden-scrollbar tw-flex tw-snap-x tw-flex-col tw-gap-1 tw-overflow-x-scroll tw-py-2 md:-tw-me-6 md:-tw-ms-16 md:tw-flex-row md:tw-pe-8 md:tw-ps-16">
          <ImageThumbnailsWithModal
            imageKeys={imageAttachments.map(
              (attachment) => attachment.fileObjectKey,
            )}
            getImageUrlFromImageKey={async (key) => {
              const url = await getUrl({ path: key });
              return url.url;
            }}
            getOptimizedImageSrc={useOptimizedImageKey}
            imageContainerClassName="tw-size-48"
            imageClassName="tw-cursor-zoom-in tw-snap-center tw-overflow-hidden tw-rounded-lg tw-border tw-shadow-sm tw-transition hover:tw-shadow-md active:tw-shadow-sm max-md:tw-w-full md:tw-h-48"
          />
        </div>
      )}
      <div className="tw-flex tw-max-w-full tw-flex-col tw-flex-wrap tw-gap-1 md:tw-flex-row">
        {nonImageAttachments.map((attachment, idx) => (
          <div
            key={idx}
            className="tw-rounded-md tw-border tw-border-neutral-200 tw-bg-neutral-50 tw-p-2"
          >
            <div className="tw-flex tw-items-center tw-gap-2">
              <div>
                <DocumentIcon className="tw-h-10 tw-w-10 tw-stroke-neutral-500" />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1">
                <div
                  className="md:tw-max-w-auto tw-max-w-20 tw-truncate tw-text-sm tw-font-bold"
                  title={attachment.fileName}
                >
                  {attachment.fileName}
                </div>
                <div
                  className="tw-cursor-pointer tw-text-sm tw-font-bold tw-text-fay-500"
                  onClick={() =>
                    getDownloadUrlAndOpen(attachment.fileObjectKey)
                  }
                >
                  Download
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ConversationMessageAttachments;
